<template>
	<div class="print-container">
		<auth-container :page="$parent.page">
			<print-menu></print-menu>

			<div class="d-flex mb-4">
				<h2 class="mr-2">Flood Control O&amp;M Program<br />Proposal {{$parent.item.proposalNumber}}</h2>
				<div class="ml-auto text-right">
					<img :src="`${publicPath}images/logos/tsswcb-logo.svg`" alt="TSSWCB Logo" class="img-fluid" style="width:170px">
				</div>
			</div>

			<b-row>
				<b-col md="7">
					<b-table-simple small class="table-definitions border-bottom">
						<b-tbody>
							<b-tr>
								<b-th>Status</b-th>
								<b-td>
									<span v-if="$parent.item.isActive" class="mr-1">Active</span>
									<span v-else class="mr-1">Inactive</span>
									<span v-if="$parent.item.isCanceled" class="mr-1">Canceled</span>
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>Sponsor</b-th>
								<b-td>
									{{$parent.sponsor.type}} {{$parent.sponsor.id}} - {{$parent.sponsor.name}}
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>Notes</b-th>
								<b-td>{{valueOrNa($parent.item.notes, 'None')}}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
				<b-col md>
					<b-table-simple small class="table-definitions border-bottom">
						<b-tbody>
							<b-tr>
								<b-th>Received</b-th>
								<b-td>{{$parent.item.dateReceived | date}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Recorded</b-th>
								<b-td>{{$parent.item.dateRecorded | date('ddd, MMM D, YYYY', 'None')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Approved</b-th>
								<b-td>{{$parent.item.dateApproved | date('ddd, MMM D, YYYY', 'None')}}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
			</b-row>

			<h3 class="mt-3">Practices</h3>
			<b-table striped responsive small show-empty :fields="activities.fields" :items="$parent.activities.items" no-local-sorting style="font-size:0.8rem">
				<template #cell(dam)="data">
					{{data.value.name}}
				</template>
				<template #cell(practice)="data">
					{{data.value.name}}
				</template>
				<template #cell(reimbursement)="data">
					{{data.value.name}}
				</template>
				<template #empty>
					<p class="my-2">This proposal does not have any practices entered.</p>
				</template>

				<template #custom-foot>
					<b-tr class="bg-light border-bottom font-weight-bold">
						<b-td colspan="3">Total</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'estimatedCost') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'approvedAmount') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'approvedAdminAmount') | number(2)}}</b-td>
						<b-td colspan="3"></b-td>
					</b-tr>
				</template>
			</b-table>
		</auth-container>
	</div>
</template>

<script>
	import PrintMenu from '@/components/helpers/PrintMenu';
	
	export default {
		name: 'ProposalPrint',
		components: { PrintMenu },
		data() {
			return {
				activities: {
					fields: [
						{ key: 'dam', label: 'Dam', sortable: false },
						{ key: 'practice', label: 'Practice', sortable: false },
						{ key: 'estimatedUnits', label: 'Est. Units', sortable: false, class: 'text-right', formatter: (value) => { return this.numberFormat(value, 2); } },
						{ key: 'estimatedCost', label: 'Est. Cost', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'approvedAmount', label: 'Approved O&M', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'approvedAdminAmount', label: 'Approved Admin', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'intendedStartDate', label: 'Intended Start', sortable: false, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
						{ key: 'intendedEndDate', label: 'Intended End', sortable: false, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
						{ key: 'reimbursement', label: 'Reimbursement Request', sortable: false }
					]
				}
			}
		}
	}
</script>